import '../index.css';

export default function Testimonials() {
  const images = [
  'https://static.lumi.new/bf/bfc63837bd60546b3333b50a6d1b1066.webp',
  'https://static.lumi.new/8f/8fd515e76f77c70a752934d62eb81629.webp',
  'https://static.lumi.new/15/15bcf214938f1136fddcb672247c46eb.webp',
  'https://static.lumi.new/41/419af163cc5088e1148d9f385b640267.webp',
  'https://static.lumi.new/e9/e9769ba997a699ffb9c6e3b16ecd0ea2.webp',
  'https://static.lumi.new/61/61163b9d6b29f833b35ef2d9d5912f24.webp',
  'https://static.lumi.new/8d/8d91fe0563e020af93e23757f4f4dcfa.webp',
  'https://static.lumi.new/8a/8a495d9f8d4fbdf13322a34c7098f11d.webp',
  'https://static.lumi.new/b3/b3639f0b5cb0ad77571c360fe646922c.webp',
  'https://static.lumi.new/8b/8b7bcad4bfa80181861e609602c8cd23.webp',
  'https://static.lumi.new/1c/1cf3c0fa8e2363ce0073525082c63db1.webp',
  'https://static.lumi.new/a1/a1ca6cbcea542b923d0d4111da4484fd.webp',
  'https://static.lumi.new/81/817140fa49c54033496175220b95fdbf.webp',
  'https://static.lumi.new/aa/aa1612836020f0959afa5086780cf918.webp',
  'https://static.lumi.new/29/290ea975b9b3cbfe4a7be4032df35d5c.webp',
  'https://static.lumi.new/2d/2d5813a32645eb586e2d51839b11c513.webp',
  'https://static.lumi.new/75/75a5664aec7a0fe541f54b9ffd2e9988.webp',
  'https://static.lumi.new/92/92c2bf0f71be6ae2b37948ac25dc1cf8.webp',
  'https://static.lumi.new/81/813d43adf80a943804910d55e32aaf14.webp',
  'https://static.lumi.new/4c/4c3b9731f6f495dd92b333e9cf4d3f61.webp',
  'https://static.lumi.new/ab/ab7c1d0f8cd4943ae5065eb134f75339.webp',
  'https://static.lumi.new/78/78a5de98747be2eb0705e916a431a3df.webp',
  'https://static.lumi.new/f2/f2ce0a44076b7e1330cf4445c9d44425.webp',
  'https://static.lumi.new/04/04792f12c3e36a51c19d7b7d07902001.webp',
  'https://static.lumi.new/2f/2ff596887751b5134150b639ad0676ec.webp',
  'https://static.lumi.new/86/86c7b547aa503f7a2b275375d376bac7.webp',
  'https://static.lumi.new/19/19a1b2a57a60522a61b8dd990d678c36.webp',
  'https://static.lumi.new/f6/f6604d484b6f874827f6fd0daad681bb.webp'];


  return (
    <section className="testimonials-section">
      <div className="section-inner">
        <h2 className="section-title">
          <span className="title-icon">&#128172;</span> Depoimentos Reais
        </h2>
        <p className="section-subtitle">Veja o que nossos usuarios dizem na minha comunidade no whatsapp</p>
        





        <div className="testimonials-grid">
          {images.map((src, i) =>
          <div key={i} className="testimonial-card">
              <img src={src} alt={`Depoimento ${i + 1}`} loading="lazy" />
            </div>
          )}
        </div>

        




      </div>
    </section>);

}